import React from 'react';
import { ArrowUpRightIcon, GithubIcon } from 'lucide-react';
import { Wordmark } from './Wordmark';
import { projects } from '../data/site';
const columns = [{
  title: 'projects',
  links: projects.map(p => ({
    label: p.wordmark,
    href: p.href
  }))
}, {
  title: 'company',
  links: [{
    label: 'About',
    href: '#about'
  }, {
    label: 'Blog',
    href: '#blog'
  }, {
    label: 'Careers',
    href: '#careers'
  }, {
    label: 'Contact',
    href: '#contact'
  }]
}, {
  title: 'community',
  links: [{
    label: 'GitHub',
    href: '#github'
  }, {
    label: 'Discord',
    href: '#discord'
  }, {
    label: 'X',
    href: '#x'
  }, {
    label: 'Bluesky',
    href: '#bluesky'
  }]
}];
export function SiteFooter() {
  return <footer id="footer" className="bg-white" data-id="element-92" data-mp="2ylooceq02tg1">
      <div className="mx-auto max-w-shell px-4 sm:px-8" data-id="element-93" data-mp="11rk4by0kf3ox">
        <div className="grid gap-12 border-b border-hairline py-16 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)]" data-id="element-94" data-mp="11oxx5zhl6q78">
          <div data-id="element-95" data-mp="15qv9d392cpgs">
            <h2 className="max-w-lg text-[clamp(1.75rem,3.2vw,2.6rem)] font-semibold leading-[1.04] tracking-tightest text-ink" data-id="element-96" data-mp="15qc0ec1e5bew">
              Try the toolchain on your own repo
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-muted" data-id="element-97" data-mp="vt7d28vt79wi">
              Install it, run your build, and compare the numbers. Everything is open source, so
              there is nothing to sign up for.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-98" data-mp="1oio535fioos7">
              <a href="#get-started" className="rounded-md bg-ink px-5 py-3 text-sm font-medium text-white transition-colors duration-150 void-ease hover:bg-void" data-id="element-99" data-mp="1tgzejf1wgx9w">
                Get started
              </a>
              <a href="#github" className="flex items-center gap-2 rounded-md border border-hairline px-5 py-3 text-sm font-medium text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-100" data-mp="1jojso6nhfojq">
                <GithubIcon className="h-4 w-4" data-id="element-101" data-mp="2m1uzfxjwzhz2" />
                Star on GitHub
                <ArrowUpRightIcon className="h-3.5 w-3.5 text-muted" data-id="element-102" data-mp="2h3bdhx5bm66p" />
              </a>
            </div>
            <p className="mt-6 inline-flex items-center gap-3 rounded-md border border-hairline bg-[#fbfbfc] px-4 py-2.5 font-mono text-xs text-ink" data-id="element-103" data-mp="2d1q0mbssdrwi">
              <span className="text-void" data-id="element-104" data-mp="28594ovfci98v">$</span> npm create vite@latest
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3" data-id="element-105" data-mp="2364x2982kjkn">
            {columns.map(col => <div key={col.title} data-id="element-106" data-mp="1ybijq0ifggxx">
                <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-muted" data-id="element-107" data-mp="1tdh0nfl04hmg">
                  {col.title}
                </p>
                <ul className="mt-4 space-y-2.5" data-id="element-108" data-mp="1pehxo0ityuxn">
                  {col.links.map(l => <li key={l.label} data-id="element-109" data-mp="1kcsluinsad8i">
                      <a href={l.href} className="text-sm text-ink transition-colors duration-150 void-ease hover:text-void" data-id="element-110" data-mp="1fer35yu9sfxk">
                        {l.label}
                      </a>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 py-8" data-id="element-111" data-mp="4ss0l8fee1w4">
          <Wordmark className="text-base" data-id="element-112" data-mp="8vestafzdotu" />
          <p className="font-mono text-[11px] text-muted" data-id="element-113" data-mp="38bv10zxxchrr">
            © {new Date().getFullYear()} — built in the open, MIT licensed
          </p>
        </div>
      </div>
    </footer>;
}